/* eslint-disable import/prefer-default-export */
export const imageContainerCss = () => ({ height: '100%' })
